import { Injectable } from "@angular/core";
import { User } from "../../shared/auth/user";
import { StateStorageService } from "../../shared/auth/state-storage.service";
import { NGXLogger } from "ngx-logger";
import { Router } from "@angular/router";

@Injectable()
export class InterceptorUtil{

    constructor(private stateStorageService: StateStorageService,
        private logger: NGXLogger,private router: Router){}
    redirectTo(user:User){

        const redirect = this.stateStorageService.getUrl();
            //this.logger.debug('redirect...1' + redirect)
            let redirectLink = redirect;
            if (this.checkRoles(user.roles, 'ROLE_MANAGEBILLERS')) {
                redirectLink = '/dashboard/admin';
            } else if (this.checkRoles(user.roles, 'ROLE_BILLER')) {
                redirectLink = '/dashboard/biller';
            } else if (this.checkRoles(user.roles, 'ROLE_BANK')) {
                redirectLink = '/dashboard/bank';
            } else if (this.checkRoles(user.roles, 'ROLE_MAILINBOX')) {
                redirectLink = '/dashboard/grs';
            } else if (this.checkRoles(user.roles, 'ROLE_MERCHANT')) {
                redirectLink = '/report/merchant-transaction-data';
            } else if (this.checkRoles(user.roles, 'ROLE_SYNDICATE')) {
                redirectLink = '/report/syndicate-transaction-data';
            } else if (this.checkRoles(user.roles, 'ROLE_RAISECMPLN')) {
                redirectLink = '/raise-complain';
            } else if (this.checkRoles(user.roles, 'ROLE_VIEWCMPLN')) {
                redirectLink = '/view-complaints';
            } else if (this.checkRoles(user.roles, 'ROLE_ACTIONCMPLN')) {
                redirectLink = '/view-complaints';
            } else if (this.checkRoles(user.roles, 'ROLE_RAISETKT')) {
                redirectLink = '';
            } else if (this.checkRoles(user.roles, 'ROLE_VIEWTKT')) {
                redirectLink = 'grs/view-tickets';
            } else if (this.checkRoles(user.roles, 'ROLE_ACTIONTKT')) {
                redirectLink = '';
            } else if (this.checkRoles(user.roles, 'ROLE_RAISEDDSPT')) {
                redirectLink = '/dms/raise-dispute';
            } else if (this.checkRoles(user.roles, 'ROLE_VIEWDSPT')) {
                redirectLink = '/dms/view-dispute';
            } else if (this.checkRoles(user.roles, 'ROLE_VIEWDDSPT')) {
                redirectLink = 'dms/view-direct-dispute';
            } else if (this.checkRoles(user.roles, 'ROLE_ACTIONDSPT')) {
                redirectLink = '';
            } else if (this.checkRoles(user.roles, 'ROLE_MANAGEEKPAYCHARGE')) {
                redirectLink = '/view-ekpay-charge';
            } else if (this.checkRoles(user.roles, 'ROLE_MANAGEBANNERS')) {
                redirectLink = '/view-banners';
            } else if (this.checkRoles(user.roles, 'ROLE_FEEDBACK')) {
                redirectLink = '/feedbacks';
            } else if (this.checkRoles(user.roles, 'ROLE_MANAGEADJUSTMENT')) {
                redirectLink = '/settlement';
            } else {
                redirectLink = '/dashboard/blank';
            }
            //this.logger.debug('redirectLink...' + redirectLink)
            this.router.navigate([redirectLink]);

            // if (redirectLink) {
            //     this.stateStorageService.storeUrl(null);
            //     this.router.navigate([redirectLink]);
            // }
    }
    checkRoles(rolesArr, roleName) {
        let flagRoles = false;
        for (let i = 0; i < rolesArr.length; i++) {
            if (rolesArr[i].trim() == roleName.trim()) {
                flagRoles = true;
                break;
            }
        }
        return flagRoles;
    }

}



// WEBPACK FOOTER //
// ./src/app/blocks/interceptor/InterceptorUtil.ts